<template>
  <div id="mb-file">
    <div class="mb-file-container">
      <div class="icon-container" @mouseenter="exitHover = true" @mouseleave="exitHover = false">
        <img draggable="false" class="controll-icon" @click="closeInfo()" :src="exitIcon" />
        <transition name="icon-fade">
          <img draggable="false" v-if="exitHover" class="controll-icon" @click="closeInfo()" :src="exitIconOn" />
        </transition>
      </div>
      <div class="line">
        <img draggable="false" class="text-icon" :src="pdfIconOn" />
        <span class="title bold">Pobierz pliki</span>
      </div>
      <br />
      <div class="line">
        <span class="text">Kliknij na wybrany plik, aby otworzyć go w zewnętrznej przeglądarce i wydrukować.</span>
      </div>
      <br />
      <div class="line">
        <span class="text">W razie problemów zainstaluj program do obsługi plików PDF.</span>
      </div>
      <div class="line blue" @click="openUrl('https://get2.adobe.com/reader/')">
        <span class="text blue link clicable">https://get2.adobe.com/reader/</span>
      </div>
      <br />
      <div
        class="line margin clicable"
        v-for="(file, fileIndex) in fileData"
        :key="'file-data-' + fileIndex"
        @click="dowloadUrl('doc/' + file)"
      >
        <img draggable="false" class="text-icon" :src="pdfDownloadIcon" />
        <span class="title">{{ file }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fileData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  name: 'mb-file',
  components: {},
  data: function () {
    return {
      exitHover: false,
      info: null,
      copyright: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    dowloadUrl(file) {
      if (file) {
        this.openUrl(window.location.origin + '/' + file);
      }
    },
    openUrl(link) {
      if (link) {
        if (this.$store.getters.isWeb) {
          window.open(link, '_blank');
        } else {
          this.$electron.shell.openExternal(link);
        }
      }
    },
    init() {
      if (this.gameData.item) {
        if (this.gameData.item.info) this.info = this.gameData.item.info;
        if (this.gameData.item.copyright) this.copyright = this.gameData.item.copyright;
      }
    },
    closeInfo() {
      this.$emit('closeInf');
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    gameData() {
      return this.$store.getters.gameData;
    },
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        console.log('%cExitIcon MbFile- error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
      return null;
    },
    exitIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-on-64px.png`);
      } catch {
        console.log(
          '%cExitIconOn MbFile- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    pdfIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/pdf-on-64px.png`);
      } catch {
        console.log('%cPdfIconOn MbFile- error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
      return null;
    },
    pdfDownloadIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/adobe_reader.png`);
      } catch {
        console.log(
          '%cpdfDownloadIcon MbFile- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variable'
$break-large: 1400px
#mb-file
  position: fixed
  top: 0
  left: -50%
  width: 150%
  height: 100%
  background: rgba(0,0,0,.5)
  z-index: 6
  display: flex
  justify-content: flex-end
  align-items: flex-start
  color: black
  font-family: $gameFontFamily
.mb-file-container
  border-radius: 10px
  position: relative
  width: 680px
  margin: 100px 260px
  background: white
  padding: 20px
  text-align: left
.icon-container
  top: 10px
  right: 10px
  position: absolute
.controll-icon
  width: 32px
  height: 32px
  top: 10px
  right: 10px
  position: absolute
  transition: .5s
    // transform: scale(.9)
  cursor: pointer
.line
  display: flex
  justify-content: flex-start
  align-items: center
.margin
  margin-bottom: 10px
.text-icon
  margin-right: 10px
  width: 48px
  height: 48px
.title
  font-size: 26px
.text
  font-size: 20px
.bold
  font-weight: bold
.blue
  color: #044a9d
.clicable
  cursor: pointer
.link
  transition: .3s
  &:hover
    text-decoration-line: underline

.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0
</style>
